import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { formatCurrency } from '~/utils/format'

export type LoanValueContainerProps = {
  requestedAmountCents?: number
}

export const LoanValueContainer: React.FC<LoanValueContainerProps> = ({ requestedAmountCents }) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Typography variant='airbnbBody1' sx={{
        fontWeight: 500,
        color: 'common.white',
        opacity: '60%'
      }}>
        Crédito pré-aprovado
      </Typography>
      <Box>
        <Typography variant='airbnbH2' sx={{
          color: 'common.white',
          marginLeft: 0.5,
          fontWeight: 'bold'
        }}>{formatCurrency(requestedAmountCents)}</Typography>
      </Box>
    </Box>
  )
}
